import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";

function Construction() {
  return (
    <>
      <Container
        fluid
        style={{
          minHeight: "80vh",
        }}
        className="App"
      >
        <Row>
          <Col className="App-construction-page-bg"></Col>
        </Row>
        <Row className="App-section App-bg-color-beige">
          <Col className="App-section-col">
            <h1
              className="tinos-regular"
              style={{
                paddingBottom: "20px",
              }}
            >
              construction
            </h1>
            <div className="quattrocento-sans-bold">
              At Urban Group, we work closely with our design team or your
              chosen architectural / interior design firm to plan your project
              from start to finish.
            </div>
            <br />
            <div className="quattrocento-sans-bold">
              Urban can turn your design and refurbishment dreams into reality.
            </div>
            <br />
            <div className="quattrocento-sans-bold">
              We have years of experience in residential extensions and
              renovations, upgrading many older properties and creating modern
              living spaces for today's residents.
            </div>
            <br />
            <div className="quattrocento-sans-bold">
              Our commercial builds and fit outs vary in scale, so do get in
              touch and we would be happy to discuss your project.
            </div>
            <br />
            <Button
              style={{
                marginBottom: "20px",
                fontFamily: "Quattrocento Sans, sans-serif",
                fontWeight: "700",
              }}
              href="mailto:HelloUrbanGroup@gmail.com"
              variant="light"
            >
              contact us
            </Button>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default Construction;
